<template>
  <router-link
      :to="url"
      :title="`View timeline and profile ${screenName}`">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: "LinkToProfile",
  props: ['screenName'],
  computed: {
    profile() {
      return this.$store.state.auth.profile
    },
    url() {
      if (this.profile && this.profile.screen_name === this.screenName) {
        return `/app/timelines/you`
      }
      return `/app/timelines/@${this.screenName}`
    }
  }
}
</script>

<style scoped>

</style>
